import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { taskBoardUri } from 'Consts/advisorUris';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { addQuery } from 'Helpers/Query';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useUserContext from 'Context/UserContext';
import modalConsts from 'Consts/ModalNames';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import { pickImplementation } from 'Helpers/Affordances';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import LinkItem from '../Item/Link';

const styles = theme => ({
  root: {},
  icon: {
    color: theme.palette.facet.primaryGray3,
    '&:hover': {
      color: theme.palette.facet.primaryBlue,
    },
  },
});

const TaskListitem = ({
  className,
  classes,
  drawerOpen,
  ...rest
}) => {
  const { householdResource } = useSimpleHousehold();
  const { userResource } = useUserContext();

  const taskboardUriParams = pickImplementation(userResource, {
    [fr.relationships.default.name]: {
      householdId: householdResource?.id(),
      link: householdResource?.relationship(fr.relationships.simpleActionItems.name).link('related').url(),
    },
  });

  const iconButtonTitle = householdResource
    ? `Add task for ${householdResource.attr('primaryClientFirstName')} ${householdResource.attr('primaryClientLastName')} [${householdResource.id()}]`
    : 'You must have a household selected in order to add a task';

  const AddTaskLink = () => (
    <IconButton
      edge="end"
      aria-label="add new task"
      className={classes.icon}
      color="white"
      title={iconButtonTitle}
      icon={AddCircleOutlineIcon}
      disabled={!householdResource}
      showTooltipOnDisabled
      onClick={() => addQuery({ modal: modalConsts.simpleActionItemGroupModal })}
      test={'add-new-task-nav-link-button'}
    />
  );

  return (
    <LinkItem
      className={classNames(classes.root, className)}
      label="Tasks"
      to={taskBoardUri(taskboardUriParams)}
      secondaryAction={AddTaskLink}
      drawerOpen={drawerOpen}
      {...rest}
    />
  );
};

TaskListitem.defaultProps = {
  className: '',
};

TaskListitem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TaskListitem);
